import { useState } from 'react'
import { Plus, Trash2, Edit2, ArrowLeft, Chrome, Globe, Apple, Monitor, Package, Cpu, Zap, Lock } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

export default function AppAuditPage() {
  const navigate = useNavigate()

  const [activeStore, setActiveStore] = useState(null)
  const [showAddForm, setShowAddForm] = useState(false)

  // App data for each store
  const [appData, setAppData] = useState({
    playstore: [
      { id: 1, name: 'Cybertection Mobile', version: '2.1.5', size: '45 MB', rating: 4.8, downloads: '100K+', status: 'Live', lastUpdated: '2 days ago' },
      { id: 2, name: 'AI Helpdesk Mobile', version: '1.3.2', size: '38 MB', rating: 4.6, downloads: '50K+', status: 'Live', lastUpdated: '1 week ago' },
      { id: 3, name: 'Cybertection Tasks', version: '1.0.1', size: '22 MB', rating: 4.5, downloads: '25K+', status: 'Live', lastUpdated: '3 days ago' },
      { id: 4, name: 'Cybertection Chat', version: '1.2.0', size: '18 MB', rating: 4.7, downloads: '30K+', status: 'Live', lastUpdated: '5 days ago' },
      { id: 5, name: 'Cybertection Security', version: '2.0.3', size: '55 MB', rating: 4.9, downloads: '75K+', status: 'Live', lastUpdated: '12 hours ago' },
    ],
    msstore: [
      { id: 1, name: 'Cybertection Desktop', version: '3.2.1', size: '120 MB', rating: 4.7, downloads: '50K+', status: 'Live', lastUpdated: '4 days ago' },
      { id: 2, name: 'Cybertection Tasks Pro', version: '2.1.0', size: '85 MB', rating: 4.5, downloads: '30K+', status: 'Live', lastUpdated: '1 week ago' },
      { id: 3, name: 'Cybertection Admin Suite', version: '1.5.2', size: '95 MB', rating: 4.8, downloads: '20K+', status: 'Live', lastUpdated: '2 days ago' },
      { id: 4, name: 'Cybertection Analytics', version: '2.0.0', size: '110 MB', rating: 4.6, downloads: '25K+', status: 'Live', lastUpdated: '6 days ago' },
    ],
    iosstore: [
      { id: 1, name: 'Cybertection', version: '2.1.4', size: '42 MB', rating: 4.8, downloads: '80K+', status: 'Live', lastUpdated: '1 day ago' },
      { id: 2, name: 'Cybertection Pro', version: '1.4.1', size: '58 MB', rating: 4.7, downloads: '45K+', status: 'Live', lastUpdated: '3 days ago' },
      { id: 3, name: 'Cybertection Security', version: '3.1.0', size: '52 MB', rating: 4.9, downloads: '60K+', status: 'Live', lastUpdated: '12 hours ago' },
      { id: 4, name: 'Cybertection Chat', version: '1.2.3', size: '35 MB', rating: 4.6, downloads: '40K+', status: 'Live', lastUpdated: '2 days ago' },
      { id: 5, name: 'Cybertection Analytics', version: '1.0.0', size: '48 MB', rating: 4.5, downloads: '20K+', status: 'Live', lastUpdated: '1 week ago' },
    ],
    macstore: [
      { id: 1, name: 'Cybertection Desktop', version: '3.2.0', size: '200 MB', rating: 4.8, downloads: '30K+', status: 'Live', lastUpdated: '5 days ago' },
      { id: 2, name: 'Cybertection Admin', version: '2.1.1', size: '180 MB', rating: 4.7, downloads: '15K+', status: 'Live', lastUpdated: '1 week ago' },
      { id: 3, name: 'Cybertection Security Suite', version: '1.5.0', size: '220 MB', rating: 4.9, downloads: '20K+', status: 'Live', lastUpdated: '3 days ago' },
      { id: 4, name: 'Cybertection Development', version: '2.0.2', size: '150 MB', rating: 4.6, downloads: '10K+', status: 'Live', lastUpdated: '2 weeks ago' },
    ],
    snapcraft: [
      { id: 1, name: 'cybertection-core', version: '3.1.2', size: '145 MB', rating: 4.7, downloads: '15K+', status: 'Live', lastUpdated: '1 week ago' },
      { id: 2, name: 'cybertection-admin', version: '2.0.1', size: '125 MB', rating: 4.8, downloads: '8K+', status: 'Live', lastUpdated: '4 days ago' },
    ],
    amazonstore: [
      { id: 1, name: 'Cybertection Mobile', version: '2.0.1', size: '40 MB', rating: 4.6, downloads: '12K+', status: 'Live', lastUpdated: '2 weeks ago' },
      { id: 2, name: 'Cybertection Tablet Edition', version: '1.5.0', size: '65 MB', rating: 4.7, downloads: '8K+', status: 'Live', lastUpdated: '3 weeks ago' },
    ],
    horizonstore: [
      { id: 1, name: 'Cybertection VR Suite', version: '1.0.0', size: '380 MB', rating: 4.9, downloads: '5K+', status: 'Live', lastUpdated: '2 months ago' },
    ],
    cyberstorestore: [
      { id: 1, name: 'Cybertection Premium', version: '1.2.0', size: '92 MB', rating: 5.0, downloads: '2K+', status: 'Live', lastUpdated: '1 day ago' },
    ],
    chromeext: [
      { id: 1, name: 'Cybertection Security Shield', version: '2.1.0', rating: 4.8, installs: '50K+', status: 'Active', lastUpdated: '3 days ago' },
    ],
    edgeext: [
      { id: 1, name: 'Cybertection Productivity Suite', version: '1.5.1', rating: 4.7, installs: '12K+', status: 'Active', lastUpdated: '1 week ago' },
    ],
  })

  const [formData, setFormData] = useState({ name: '', version: '', size: '', rating: '', downloads: '' })

  const stores = [
    { id: 'playstore', label: 'Google Playstore', icon: Zap, color: 'from-green-600', emoji: '🪟', count: appData.playstore.length },
    { id: 'msstore', label: 'Microsoft App Store', icon: Monitor, color: 'from-blue-600', emoji: '🪟', count: appData.msstore.length },
    { id: 'iosstore', label: 'Apple App Store iOS', icon: Apple, color: 'from-gray-600', emoji: '📲', count: appData.iosstore.length },
    { id: 'macstore', label: 'Apple App Store macOS', icon: Apple, color: 'from-gray-700', emoji: '🍎', count: appData.macstore.length },
    { id: 'snapcraft', label: 'Linux Snapcraft', icon: Cpu, color: 'from-orange-600', emoji: '🐧', count: appData.snapcraft.length },
    { id: 'amazonstore', label: 'Amazon App Store', icon: Package, color: 'from-yellow-600', emoji: '🛒', count: appData.amazonstore.length },
    { id: 'horizonstore', label: 'Meta Horizon App Store', icon: Globe, color: 'from-purple-600', emoji: '🥽', count: appData.horizonstore.length },
    { id: 'cyberstorestore', label: 'Cybertection App Store', icon: Lock, color: 'from-red-600', emoji: '🛡️', count: appData.cyberstorestore.length },
    { id: 'chromeext', label: 'Chrome Extensions', icon: Chrome, color: 'from-yellow-500', emoji: '⚙️', count: appData.chromeext.length },
    { id: 'edgeext', label: 'Edge Extensions', icon: Globe, color: 'from-blue-500', emoji: '🔵', count: appData.edgeext.length },
  ]

  const handleAddApp = () => {
    if (!formData.name || !activeStore) return alert('Name and store required')

    setAppData(prev => ({
      ...prev,
      [activeStore]: [...prev[activeStore], {
        id: Date.now(),
        ...formData,
        status: 'Live',
        lastUpdated: 'Just now'
      }]
    }))

    setFormData({ name: '', version: '', size: '', rating: '', downloads: '' })
    setShowAddForm(false)
  }

  const handleDeleteApp = (storeId, appId) => {
    if (confirm('Remove this application?')) {
      setAppData(prev => ({
        ...prev,
        [storeId]: prev[storeId].filter(app => app.id !== appId)
      }))
    }
  }

  const currentApps = activeStore ? appData[activeStore] : []

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-blue-950 to-slate-900 p-8">
      <div className="max-w-7xl mx-auto">
        <button onClick={() => navigate('/tools-showcase')} className="flex items-center gap-2 text-blue-400 hover:text-blue-300 mb-6 font-semibold">
          <ArrowLeft size={20} /> Back to Tools
        </button>

        <div className="mb-8">
          <h1 className="text-4xl font-bold text-white mb-2">Cybertection App Audit</h1>
          <p className="text-slate-400">Manage and audit all company applications across different platforms and stores</p>
        </div>

        {/* Store Selection Grid */}
        {!activeStore ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
            {stores.map(store => {
              const Icon = store.icon
              return (
                <button
                  key={store.id}
                  onClick={() => setActiveStore(store.id)}
                  className={`p-6 rounded-xl border-2 transition-all text-left bg-gradient-to-br ${store.color}/10 border-blue-500/20 hover:border-blue-500/40 hover:shadow-lg`}
                >
                  <div className="text-3xl mb-2">{store.emoji}</div>
                  <Icon size={24} className="text-blue-400 mb-3" />
                  <p className="text-sm font-semibold text-white">{store.label}</p>
                  <p className="text-xs text-slate-400 mt-2">{store.count} Applications</p>
                </button>
              )
            })}
          </div>
        ) : (
          <div className="space-y-6">
            {/* Store Header */}
            <div className="flex items-center justify-between mb-6">
              <div>
                <button
                  onClick={() => setActiveStore(null)}
                  className="flex items-center gap-2 text-blue-400 hover:text-blue-300 mb-4 font-semibold"
                >
                  <ArrowLeft size={20} /> Back to Stores
                </button>
                <h2 className="text-3xl font-bold text-white">
                  {stores.find(s => s.id === activeStore)?.label}
                </h2>
              </div>
              <div className="text-right">
                <p className="text-slate-400 text-sm">Total Apps</p>
                <p className="text-4xl font-bold text-blue-400">{currentApps.length}</p>
              </div>
            </div>

            {/* Add App Button */}
            {!showAddForm ? (
              <button
                onClick={() => setShowAddForm(true)}
                className="w-full px-6 py-3 bg-gradient-to-r from-blue-600 to-cyan-500 text-white rounded-lg font-bold hover:shadow-lg hover:shadow-blue-500/50 transition-all flex items-center justify-center space-x-2"
              >
                <Plus size={20} />
                <span>Add Application</span>
              </button>
            ) : (
              <div className="bg-slate-800/50 rounded-lg p-6 border border-blue-500/20 space-y-4">
                <h3 className="text-white font-semibold">Add New Application</h3>
                <input
                  type="text"
                  placeholder="Application Name"
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  className="w-full px-4 py-2 bg-slate-700 border border-blue-500/20 rounded-lg text-white placeholder-slate-500"
                />
                <div className="grid grid-cols-2 gap-4">
                  <input
                    type="text"
                    placeholder="Version"
                    value={formData.version}
                    onChange={(e) => setFormData({...formData, version: e.target.value})}
                    className="px-4 py-2 bg-slate-700 border border-blue-500/20 rounded-lg text-white placeholder-slate-500"
                  />
                  <input
                    type="text"
                    placeholder="Size"
                    value={formData.size}
                    onChange={(e) => setFormData({...formData, size: e.target.value})}
                    className="px-4 py-2 bg-slate-700 border border-blue-500/20 rounded-lg text-white placeholder-slate-500"
                  />
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <input
                    type="text"
                    placeholder="Rating (e.g., 4.8)"
                    value={formData.rating}
                    onChange={(e) => setFormData({...formData, rating: e.target.value})}
                    className="px-4 py-2 bg-slate-700 border border-blue-500/20 rounded-lg text-white placeholder-slate-500"
                  />
                  <input
                    type="text"
                    placeholder="Downloads/Installs"
                    value={formData.downloads}
                    onChange={(e) => setFormData({...formData, downloads: e.target.value})}
                    className="px-4 py-2 bg-slate-700 border border-blue-500/20 rounded-lg text-white placeholder-slate-500"
                  />
                </div>
                <div className="flex gap-3">
                  <button onClick={handleAddApp} className="flex-1 px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg font-semibold">Add App</button>
                  <button onClick={() => setShowAddForm(false)} className="flex-1 px-4 py-2 bg-slate-600 hover:bg-slate-700 text-white rounded-lg font-semibold">Cancel</button>
                </div>
              </div>
            )}

            {/* Apps List */}
            <div className="space-y-3">
              {currentApps.map(app => (
                <div key={app.id} className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-xl border border-blue-500/20 p-4 hover:border-blue-500/40 transition-all">
                  <div className="flex items-start justify-between mb-3">
                    <div className="flex-1">
                      <h3 className="text-lg font-bold text-white">{app.name}</h3>
                      <div className="flex flex-wrap gap-3 mt-2 text-sm text-slate-400">
                        {app.version && <span>📦 v{app.version}</span>}
                        {app.size && <span>📊 {app.size}</span>}
                        {(app.rating || app.downloads) && <span>⭐ {app.rating} • 📥 {app.downloads || app.installs}</span>}
                      </div>
                    </div>
                    <span className={`px-3 py-1 rounded-full text-xs font-bold ${app.status === 'Live' || app.status === 'Active' ? 'bg-green-500/30 text-green-300' : 'bg-yellow-500/30 text-yellow-300'}`}>
                      {app.status}
                    </span>
                  </div>
                  <div className="flex items-center justify-between text-xs text-slate-400">
                    <span>Last updated: {app.lastUpdated}</span>
                    <div className="flex gap-2">
                      <button className="px-3 py-1 bg-blue-600/50 hover:bg-blue-600 text-blue-300 rounded font-semibold">Edit</button>
                      <button onClick={() => handleDeleteApp(activeStore, app.id)} className="px-3 py-1 bg-red-600/50 hover:bg-red-600 text-red-300 rounded font-semibold flex items-center gap-1">
                        <Trash2 size={12} />
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
